import axios from "axios";

const api = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_URL || 'http://localhost:5000/api/v1',
});

export default api;
